<template>
  <div>
    <HTMLHeader></HTMLHeader>
    <div class="wrapper">
      <HTMLMenu></HTMLMenu>

      <div class="content">
        <div class="container">
          <div class="floating-buttons">
            <router-link class="fl-button grey" :to="{ path: '/doors/' }"><i class="fa fa-angle-left"></i></router-link>
            <button :disabled="is_save" class="fl-button" type="button" v-on:click="save"><i class="fa fa-save"></i></button>
          </div>
          <h1>Ajtó</h1>
          <div class="row">
            <div class="col-xs-6">
              <div class="row">
                <div class="col-xs-12">
                  <inputbox id="name" label="Megnevezés" v-bind:errors="errors" name="name" v-model="form.name"></inputbox>
                  <comboboxV2 id="controller_id" label="Kontroller" v-bind:errors="errors" name="controller_id" v-model="form.controller_id" :options="controllers" :change="controllerChange"></comboboxV2>
                  <comboboxV2 id="reader_id" label="Olvasó" v-bind:errors="errors" name="reader_id" v-model="form.reader_id" :options="readers"></comboboxV2>
                  <comboboxV2 id="relay_id" label="Relé" v-bind:errors="errors" name="relay_id" v-model="form.relay_id" :options="relays"></comboboxV2>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <comboboxV2 id="building_id" label="Épület" v-bind:errors="errors" name="building_id" v-model="form.building_id" :options="buildings" :change="buildingChange"></comboboxV2>
                </div>
                <div class="col-sm-6">
                  <comboboxV2 id="building_level_id" label="Épület szint" v-bind:errors="errors" name="building_level_id" :options="building_levels" v-model="form.building_level_id"></comboboxv2>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <inputbox regexp_filter="[0-9]+" id="x_coord" label="X koordináta" v-bind:errors="errors" name="x_coord" v-model="form.x_coord"></inputbox>
                </div>
                <div class="col-sm-6">
                  <inputbox regexp_filter="[0-9]+" id="y_coord" label="Y koordináta" v-bind:errors="errors" name="y_coord" v-model="form.y_coord"></inputbox>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <toggle id="additional" label="Kiegészítő eszköz" v-bind:errors="errors" name="additional" v-model="form.additional"></toggle>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <inputbox id="name_addition" label="Megnevezés kiegészítés" v-bind:errors="errors" name="name_addition" v-model="form.name_addition"></inputbox>
                </div>
                <div class="col-sm-12">
                  <toggle id="open_warning" label="Nyitva tartási figyelmeztetés (olyan záraknál kell beállítani, ahol a hosszú nyitójel tönkreteheti azt)" v-bind:errors="errors" name="open_warning" v-model="form.open_warning"></toggle>
                </div>
              </div>
              <textareabox id="comment" label="Megjegyzés" v-bind:errors="errors" name="comment" v-model="form.comment"></textareabox>
            </div>
          </div>
        </div>
      </div>
    </div>
    <HTMLFooter></HTMLFooter>
    <ProgressInfo :show="is_save"/>
  </div>
</template>
<script>
export default {
  components: {
  },

  data: function() {
    return {
      form: {
        element_id: '',
        name: '',
        controller_id: 0,
        building_id: 0,
        building_level_id: 0,
        reader_id: 0,
        x_coord: '',
        y_coord: '',
        comment: '',
        name_addition: '',
        additional: {
          value: 1,
          selected: false
        },
        open_warning: {
          value: 1,
          selected: false
        },
      },
      controllers: [],
      buildings: [],
      building_levels: [],
      readers: [],
      relays: [],
      errors: [],
      is_save: false
    }
  },

  mounted: function() {
    var _this = this;

    this.$root.checkRootUserHasSet(function() {
      _this.$root.ajax('door/edit/' + _this.$root.user.apikey + '/' + (_this.$route.query.doorID != undefined ? _this.$route.query.doorID : 0), {
        success: function(response) {
          _this.form = response.door;
          _this.getBuildings();
          _this.getBuildingLevels();
          _this.getControllers();
          _this.getReaders();
          _this.getRelays();
        }
      });
    });
  },

  methods: {
    getControllers: function() {
      var _this = this;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('controllers/' + _this.$root.user.apikey + '/1', {
          method: 'POST',
          success: function(response) {
            var tmp = [{
              label: '- válassz -',
              value: 0
            }];

            response.controllers.map(function(controller) {
              tmp.push({
                label: controller.name,
                value: controller.element_id
              })
            });
            _this.controllers = tmp;
          }
        });
      });
    },

    getReaders: function() {
      var _this = this;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('readers/' + _this.$root.user.apikey + '/1', {
          method: 'POST',
          data: {
            'controller_id': _this.form.controller_id
          },
          success: function(response) {
            var tmp = [{
              label: '- válassz -',
              value: 0
            }];

            response.readers.map(function(reader) {
              tmp.push({
                label: reader.name,
                value: reader.element_id
              })
            });
            _this.readers = tmp;
          }
        });
      });
    },

    getRelays: function() {
      var _this = this;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('relays/' + _this.$root.user.apikey + '/1', {
          method: 'POST',
          data: {
            'controller_id': _this.form.controller_id
          },
          success: function(response) {
            var tmp = [{
              label: '- válassz -',
              value: 0
            }];

            response.relays.map(function(relay) {
              tmp.push({
                label: relay.name,
                value: relay.element_id
              })
            });
            _this.relays = tmp;
          }
        });
      });
    },

    getBuildings: function() {
      var _this = this;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('buildings/' + _this.$root.user.apikey + '/1', {
          method: 'POST',
          data: {},
          success: function(response) {
            var tmp = [{
              label: '- válassz -',
              value: 0
            }];

            response.buildings.map(function(building) {
              tmp.push({
                label: building.name,
                value: building.id
              })
            });
            _this.buildings = tmp;
          }
        });
      });
    },

    getBuildingLevels: function(setToNull = 0) {
      var _this = this;

      if (this.form.building_id == 0) {
        this.building_levels = [{
          label: '- válassz -',
          value: 0
        }];
        this.form.building_level_id = 0;
        return;
      }

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('building_levels/' + _this.$root.user.apikey + '/1', {
          method: 'POST',
          data: {
            building_id: _this.form.building_id
          },
          success: function(response) {
            var tmp = [{
              label: '- válassz -',
              value: 0
            }];

            response.levels.map(function(level) {
              tmp.push({
                label: level.name,
                value: level.id
              })
            });
            _this.building_levels = tmp;

            if (setToNull == 1)
              _this.form.building_level_id = 0;
          }
        });
      });
    },

    controllerChange: function() {
      this.getReaders();
      this.getRelays();
    },

    buildingChange: function() {
      this.getBuildingLevels(1);
    },

    save: function (event) {
      var _this = this;
      var form = JSON.parse(JSON.stringify(_this.form));
      this.is_save = true;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('door/save/' + _this.$root.user.apikey, {
          method: 'POST',
          data: form,
          waitForSaveInfo: true,
          success: function(response) {
            _this.is_save = false;

            if (response.errors.length > 0) {
              _this.errors = response.errors;
            } else {
              _this.$router.push({path: '/doors'});
            }
          }
        });
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// door.vue?44174e4e